import * as z from 'zod';

import { BankruptcyId, ForeclosureId, PayoffId } from '../BrandedIds';
import { zodJSInstantDate } from '../dates/BrandedDate';
import { zodBrandedUuid } from '../utils/Zod';
import {
  LoanStatusActive,
  LoanStatusArchived,
  LoanStatusForeclosure,
  LoanStatusLiquidated,
  LoanStatusPendingActivation,
  LoanStatusPendingTransfer,
  LoanStatusPreActive,
  LoanStatusReo,
  LoanStatusTransferred,
} from './LoanStatus';

const LoanStatusHistoryBase = z.object({
  changedAt: zodJSInstantDate,
});

const LoanStatusHistoryPendingActivation = LoanStatusHistoryBase.extend({
  status: LoanStatusPendingActivation,
});

const LoanStatusHistoryPreActive = LoanStatusHistoryBase.extend({
  status: LoanStatusPreActive,
});

const LoanStatusHistoryActive = LoanStatusHistoryBase.extend({
  status: LoanStatusActive,
});

const LoanStatusHistoryArchived = LoanStatusHistoryBase.extend({
  status: LoanStatusArchived,
});

const LoanStatusHistoryPendingTransfer = LoanStatusHistoryBase.extend({
  status: LoanStatusPendingTransfer,
});

const LoanStatusHistoryTransferred = LoanStatusHistoryBase.extend({
  status: LoanStatusTransferred,
});

// @migrationTodo remove foreclosure from array after migration to remove it as a status
const LoanStatusHistoryForeclosure = LoanStatusHistoryBase.extend({
  status: LoanStatusForeclosure,
  foreclosureId: zodBrandedUuid<ForeclosureId>(),
});

const LoanStatusHistoryPaidOff = LoanStatusHistoryBase.extend({
  status: z.literal('paidOff'),
  payoffId: zodBrandedUuid<PayoffId>(),
});

const LoanStatusHistoryPaidOffUntracked = LoanStatusHistoryBase.extend({
  status: z.literal('paidOffUntracked'),
});

const LoanStatusHistoryReo = LoanStatusHistoryBase.extend({
  status: LoanStatusReo,
});

const LoanStatusHistoryLiquidated = LoanStatusHistoryBase.extend({
  status: LoanStatusLiquidated,
});

// @migrationTodo remove bankruptcy from array after migration to remove it as a status
const LoanStatusHistoryBankruptcy = LoanStatusHistoryBase.extend({
  status: z.literal('bankruptcy'),
  bankruptcyId: zodBrandedUuid<BankruptcyId>(),
});

export const LoanStatusHistoryEntry = z.discriminatedUnion('status', [
  LoanStatusHistoryPendingActivation,
  LoanStatusHistoryPreActive,
  LoanStatusHistoryActive,
  LoanStatusHistoryArchived,
  LoanStatusHistoryPendingTransfer,
  LoanStatusHistoryTransferred,
  LoanStatusHistoryForeclosure, // @migrationTodo remove foreclosure from array after migration to remove it as a status
  LoanStatusHistoryPaidOff,
  LoanStatusHistoryPaidOffUntracked,
  LoanStatusHistoryReo,
  LoanStatusHistoryLiquidated,
  LoanStatusHistoryBankruptcy, // @migrationTodo remove bankruptcy from array after migration to remove it as a status
]);
export type LoanStatusHistoryEntry = z.infer<typeof LoanStatusHistoryEntry>;
